export const gitCommit = 'd4ff8737'
